import moment from 'moment';

export const getPassengersDeniedUKEntry = ({ outbound = [], inbound = [] }) => {
  const legsInFuture = [...outbound, ...inbound].filter((leg) => moment(leg.timing?.date).isAfter(moment()));
  return legsInFuture?.flatMap((leg) =>
    [...(leg?.products || [])].filter(
      (e) => e.isUKEntryDenied && !e.cancelled && !e.provisional && !e.isCheckedIn && !e.isPrrRefunded && !e.isSuspended && !e.isPlaceholder
    )
  );
};
